[
  "#4e79a7",
  "#f28e2b",
  "#e15759",
  "#76b7b2",
  "#59a14f",
  "#edc948",
  "#b07aa1",
  "#ff9da7",
  "#9c755f",
  "#bab0ac",
  "#86bcb6",
  "#d37295",
  "#fabfd2",
  "#b6992d",
  "#499894",
  "#e58606",
  "#5d69b1",
  "#52bca3",
  "#99c945",
  "#cc61b0",
  "#24796c",
  "#daa51b",
  "#2f8ac4",
  "#764e9f"
]
